import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47b0a65d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-[320px]" }
const _hoisted_2 = { class: "item-tooltip-category" }
const _hoisted_3 = { class: "flex gap-x-3" }
const _hoisted_4 = { class: "flex flex-col justify-center gap-x-3" }
const _hoisted_5 = { class: "mt-1.5 flex flex-col gap-1.5" }

import { PropType, Ref, ref } from 'vue';
import {
  BlackDesertItemTooltip,
  BlackDesertItemTooltipSection,
  BlackDesertItemType,
} from '@blackdesertmarket/interfaces';
import { ItemTooltipSectionId } from '@/enums/item-tooltip';
import { UseItemTooltipReturn, useItemTooltip } from '@/composables/item-tooltip/use-item-tooltip';
import { UseItemTypeReturn, useItemType } from '@/composables/item-type/use-item-type';
import { UseItemReturn, useItem } from '@/composables/item/use-item';
import { UseItemIconFetchReturn, useItemIconFetch } from '@/composables/item/use-item-icon-fetch';
import { TranslateKey, useInject } from '@/composables/use-inject';
import ListItemIcon from '@/components/ListItem/ListItemIcon.vue';
import ListItemName from '@/components/ListItem/ListItemName.vue';
import ListItemTooltipProperty from '@/components/ListItem/ListItemTooltip/ListItemTooltipProperty.vue';
import ListItemTooltipSection from '@/components/ListItem/ListItemTooltip/ListItemTooltipSection.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ListItemTooltip',
  props: {
  itemType: {
    type: Object as PropType<BlackDesertItemType>,
    required: true,
  },
  itemTooltip: {
    type: Object as PropType<BlackDesertItemTooltip>,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const translate = useInject(TranslateKey);
const itemComposable: UseItemReturn = useItem(props.itemType);
const itemTypeComposable: UseItemTypeReturn = useItemType(props.itemType);
const itemTooltipComposable: UseItemTooltipReturn = useItemTooltip(props.itemTooltip);
const itemIconFetch: UseItemIconFetchReturn = useItemIconFetch(props.itemType.id);

const itemGradeText: Ref<string> = ref('mb-0.5 text-lg');
const itemGradeBorder: Ref<string> = ref('');
const itemIcon: Ref<string> = ref('');
const centralMarketInformationId: Ref<string> = ref('');

const centralMarketInformationOrder: ItemTooltipSectionId[] = [
  ItemTooltipSectionId.ENHANCEMENT_TYPE,
  ItemTooltipSectionId.PERSONAL_TRANSACTION,
];

const getCentralMarketInformationData = (): BlackDesertItemTooltipSection => {
  const centralMarketInformation: string = translate('tooltip.centralMarketInformation');
  const marketPrice: string = translate('tooltip.marketPrice');
  const warehouseCapacity: string = translate('generic.warehouseCapacity');

  return {
    id: ItemTooltipSectionId.CENTRAL_MARKET_INFORMATION,
    name: centralMarketInformation,
    values: [`${marketPrice}: ${itemComposable.getBasePrice()}`, `${warehouseCapacity}: —`],
  };
};

if (props.itemType.grade) {
  itemGradeText.value = `mb-0.5 text-lg text:item-grade-${props.itemType.grade}`;
  itemGradeBorder.value = `border:item-grade-${props.itemType.grade}`;
}

if (!itemIcon.value) {
  itemIconFetch.fetch().then((icon: string): void => {
    itemIcon.value = icon;
  });
}

if (!centralMarketInformationId.value) {
  for (const sectionId of centralMarketInformationOrder) {
    const itemTooltipSection: BlackDesertItemTooltipSection | undefined = props.itemTooltip.sections.find(
      (section: BlackDesertItemTooltipSection): boolean => section.id === sectionId,
    );

    if (itemTooltipSection) {
      centralMarketInformationId.value = itemTooltipSection.id;
      break;
    }
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(props.itemTooltip.category), 1),
    _createVNode(ListItemName, {
      name: _unref(itemTypeComposable).getItemName(),
      class: _normalizeClass(itemGradeText.value)
    }, null, 8, ["name", "class"]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(ListItemIcon, {
        src: itemIcon.value,
        text: _unref(itemTypeComposable).getItemIconText(),
        class: _normalizeClass(itemGradeBorder.value)
      }, null, 8, ["src", "text", "class"]),
      _createElementVNode("div", _hoisted_4, [
        (props.itemTooltip.damage)
          ? (_openBlock(), _createBlock(ListItemTooltipProperty, {
              key: 0,
              label: "AP",
              value: props.itemTooltip.damage,
              class: "text-2xl leading-7"
            }, null, 8, ["value"]))
          : _createCommentVNode("", true),
        (props.itemTooltip.defense)
          ? (_openBlock(), _createBlock(ListItemTooltipProperty, {
              key: 1,
              label: "DP",
              value: props.itemTooltip.defense,
              class: "text-2xl leading-7"
            }, null, 8, ["value"]))
          : _createCommentVNode("", true),
        (props.itemTooltip.accuracy)
          ? (_openBlock(), _createBlock(ListItemTooltipProperty, {
              key: 2,
              label: _unref(translate)('tooltip.accuracy'),
              value: props.itemTooltip.accuracy,
              class: "text-lg leading-6"
            }, null, 8, ["label", "value"]))
          : _createCommentVNode("", true),
        (props.itemTooltip.evasion)
          ? (_openBlock(), _createBlock(ListItemTooltipProperty, {
              key: 3,
              label: _unref(translate)('tooltip.evasion'),
              value: props.itemTooltip.evasion
            }, null, 8, ["label", "value"]))
          : _createCommentVNode("", true),
        (props.itemTooltip.evasion)
          ? (_openBlock(), _createBlock(ListItemTooltipProperty, {
              key: 4,
              label: _unref(translate)('tooltip.damageReduction'),
              value: props.itemTooltip.evasion
            }, null, 8, ["label", "value"]))
          : _createCommentVNode("", true),
        (props.itemTooltip.weight)
          ? (_openBlock(), _createBlock(ListItemTooltipProperty, {
              key: 5,
              label: _unref(translate)('tooltip.weight'),
              value: _unref(itemTooltipComposable).getItemWeight()
            }, null, 8, ["label", "value"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.itemTooltip.sections, (section) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: section.id
        }, [
          _createVNode(ListItemTooltipSection, {
            "item-tooltip-section": section,
            "format-name": _unref(itemTooltipComposable).getSectionFormatName(section.id),
            "format-value": _unref(itemTooltipComposable).getSectionFormatValue(section.id),
            class: _normalizeClass(_unref(itemTooltipComposable).getSectionClass(section.id)),
            "name-class": _unref(itemTooltipComposable).getSectionNameClass(section.id),
            "value-class": _unref(itemTooltipComposable).getSectionValueClass(section.id)
          }, null, 8, ["item-tooltip-section", "format-name", "format-value", "class", "name-class", "value-class"]),
          (section.id === centralMarketInformationId.value)
            ? (_openBlock(), _createBlock(ListItemTooltipSection, {
                key: 0,
                "item-tooltip-section": getCentralMarketInformationData(),
                class: _normalizeClass(_unref(itemTooltipComposable).getSectionClass(_unref(ItemTooltipSectionId).CENTRAL_MARKET_INFORMATION)),
                "name-class": _unref(itemTooltipComposable).getSectionNameClass(_unref(ItemTooltipSectionId).CENTRAL_MARKET_INFORMATION),
                "value-class": _unref(itemTooltipComposable).getSectionValueClass(_unref(ItemTooltipSectionId).CENTRAL_MARKET_INFORMATION)
              }, null, 8, ["item-tooltip-section", "class", "name-class", "value-class"]))
            : _createCommentVNode("", true)
        ], 64))
      }), 128))
    ])
  ]))
}
}

})